<template>
  <div>
    <div
      ref="tooltipIcon"
      @mouseenter="openPopper"
      @mouseleave="closePopper"
    >
      <slot name="icon">
        <div class="btn-icon btn-icon-blue">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"  class="w-5 h-5">
    <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
</svg>
        </div>
      </slot>
    </div>

    <Transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated animate__fadeOut animate__faster"
      enter-from-class="opacity-0"
      leave-from-class="opacity-0"
    >
      <div
        v-if="showPopper"
        ref="tooltipText"
        role="tooltip"
        class="transition-[background] ease-in-out z-50"
        :class="{ 'bg-gray-200 p-3 rounded-lg shadow-md': useBackground }"
        @mouseenter="openPopper"
        @mouseleave="closePopper"
      >
        <slot>
          <p class="max-w-60 text-sm">
            {{ $props.tooltip }}
          </p>
        </slot>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { createPopper } from '@popperjs/core';
import { ref, useTemplateRef, watch } from 'vue';

const props = withDefaults(
  defineProps<{
    tooltip?: string;
    offset?: [number, number];
    delay?: number;
    useBackground?: boolean;
  }>(),
  {
    offset: () => [0, 5],
    useBackground: true,
  },
);

const showPopper = ref(false);
const tooltipIcon = useTemplateRef('tooltipIcon');
const tooltipText = useTemplateRef('tooltipText');

watch([tooltipIcon, tooltipText], (newValue) => {
  if(newValue[0] && newValue[1]) {
    createPopper(tooltipIcon.value, tooltipText.value, {
      placement: 'right',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: props.offset,
          },
        },
      ],
    });
  }
}, { immediate: true });

const timeOutRef = ref();

const openPopper = () => {
  if(timeOutRef.value) {
    clearTimeout(timeOutRef.value);
  }

  showPopper.value = true;
};

const closePopper = () => {
  if(props.delay) {
    timeOutRef.value = setTimeout(() => {
      showPopper.value = false;
    }, props.delay);
  } else {
    showPopper.value = false;
  }
};
</script>

<style scoped></style>
